define.alias("shared/components/shared/credentials/tiktok-refresh-confirm", "calendar/components/shared/credentials/tiktok-refresh-confirm");